export const cardHelper = {
  methods: {
    getCardIcon: function (brand) {
      switch (brand) {
        case "visa":
          return "fa fa-cc-visa"
        case "mastercard":
          return "fa fa-cc-mastercard"
        case "stripe":
          return "fa fa-cc-stripe"
        case "paypal":
          return "fa fa-cc-paypal"
        case "discover":
          return "fa fa-cc-discover"
        case "amex":
          return "fa fa-cc-amex"
        case "jcb":
          return "fa fa-cc-jcb"
        case "diners-club":
          return "fa fa-cc-diners-club"
      }
      return "fa fa-credit-card"
    }
  }
}
